import React, { useState, useEffect, useRef } from 'react';
import './FichasTecnicas.css';

import { useTheme } from '@mui/material/styles';
import { DataGrid } from '@mui/x-data-grid';

import {
  Snackbar, Alert, TextField, Button, MenuItem, IconButton, useMediaQuery, Dialog, DialogTitle, DialogContent, DialogActions, ButtonGroup,
  tooltipClasses, Typography, styled, Zoom, Tooltip, FormControl, FormLabel, RadioGroup, FormControlLabel, Radio, List, ListItem, ListItemText,
  Divider, Accordion, AccordionSummary, AccordionDetails, Grid, Checkbox
} from '@mui/material';

import { QRCodeCanvas } from "qrcode.react";
import QRCode from "qrcode";
import { jsPDF } from "jspdf";

import FilterAltIcon from '@mui/icons-material/FilterAlt';
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';

import MostrarError from '../../components/AccionesPartes/MostrarError';
import CargaSpinner from '../../components/AccionesPartes/CargaSpinner';

const HtmlTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} disableInteractive />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#f5f5f9',
    color: 'rgba(0, 0, 0, 0.87)',
    maxWidth: 220,
    fontSize: theme.typography.pxToRem(12),
    border: '1px solid #dadde9',
  },
}));

function FichasTecnicas() {

  const API_URL = 'https://api.workers.grupotel.com/';

  const fd = new FormData();
  const requestOptions = {
    method: 'POST',
    body: fd
  };

  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));

  //Conjunto para mostrar un Alert con el resultado de la petición
  const [mensajeError, setMensajeError] = useState('');
  const [tipoError, setTipoError] = useState('');
  const [contadorError, setContadorError] = useState(1);
  const [estadoAlert, setEstadoAlert] = React.useState(false);

  //Funcion basica para mostrar alert de errores o success.
  const mostrarError = (mensajeError, tipoError) => {
    setMensajeError(mensajeError);
    if (tipoError) {
      setTipoError(tipoError);
    } else {
      setTipoError("error");
    }
    setContadorError(contadorError + 1);
    setEstadoAlert(true);
    const timer2 = setTimeout(() => {
      setEstadoAlert(false);
    }, 3000);
    return () => clearTimeout(timer2);
  };

  const [contadorSpinner, setContadorSpinner] = React.useState(false);

  const ColumnaQR = ({ id, nombre }) => {
    const [open, setOpen] = useState(false);
    const qrRef = useRef(null);

    const url = `https://api.workers.grupotel.com/documentos/productos_quimicos/${String(
      id
    ).padStart(6, "0")}.pdf`;

    // Función para descargar el QR como imagen
    const descargarQR = () => {
      const canvas = qrRef.current.querySelector("canvas");
      const pngUrl = canvas
        .toDataURL("image/png")
        .replace("image/png", "image/octet-stream");

      const nombreLimpio = nombre
        .toLowerCase()
        .normalize("NFD") // elimina acentos
        .replace(/[\u0300-\u036f]/g, "") // más limpieza de acentos
        .replace(/[^a-z0-9]/gi, "_"); // todo lo que no sea alfanumérico => "_"

      const link = document.createElement("a");
      link.href = pngUrl;
      link.download = `QR_${id}_${nombreLimpio}.png`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    return (
      <>
        <IconButton className='icon-button' onClick={() => setOpen(true)}>
          <QrCodeScannerIcon />
        </IconButton>
        <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
          <DialogTitle>QR: {id} {nombre}</DialogTitle>
          <DialogContent sx={{ textAlign: "center", p: 3 }}>
            <div ref={qrRef}>
              <QRCodeCanvas
                id={`qrCode-${id}`}
                value={url}
                size={220}
                fgColor={"#00A2DC"} // Color Azul QR
                // fgColor={"#000000"} // Color Negro
                bgColor={"#ffffff"}
                level={"H"}
              />
            </div>
            <Typography variant="body2" sx={{ mt: 2 }}>
              Escanea para abrir el PDF
            </Typography>
          </DialogContent>
          <DialogActions>
            <ButtonGroup className="botonera" variant="contained" aria-label="outlined button group">
              <Button className="colorGrupo borrarBoton" onClick={() => setOpen(false)}>Cancelar</Button>
              <Button className="colorGrupo" onClick={descargarQR}>Descargar QR</Button>
            </ButtonGroup>
          </DialogActions>
        </Dialog>
      </>
    );
  };

  const columnas = [
    {
      headerClassName: 'header-grid', field: 'id', headerName: 'ID', width: 80,
    },
    {
      headerClassName: 'header-grid', field: 'nombre', headerName: 'Nombre', width: 300,
    },
    {
      headerClassName: 'header-grid', field: 'proveedor', headerName: 'Proveedor', width: 170,
    },
    {
      headerClassName: 'header-grid', field: 'marca', headerName: 'Marca', width: 170,
    },
    {
      headerClassName: 'header-grid', field: 'eco', headerName: 'Eco', width: 40,
      renderCell: (params) => {
        let eco = params.row.eco;

        return eco === 1 ? (
          <IconButton className="icon-button" rel="noopener noreferrer">
            <CheckCircleIcon color="success" />
          </IconButton>
        ) : ' ';
      }
    },
    {
      headerClassName: 'header-grid', field: 'pdf', headerName: 'PDF', width: 40, sortable: false, align: 'center',
      renderCell: (params) => {
        const id = params.row.id;
        const url = `https://api.workers.grupotel.com/documentos/productos_quimicos/${String(id).padStart(6, '0')}.pdf`;

        return (
          <IconButton
            className='icon-button'
            component="a"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <PictureAsPdfIcon />
          </IconButton>
        );
      }
    },
    {
      headerClassName: 'header-grid', field: 'qr', headerName: 'QR', width: 40, sortable: false, align: 'center',
      renderCell: (params) => <ColumnaQR id={params.row.id} nombre={params.row.nombre} />
    }
  ]

  const columnasDep = [
    {
      headerClassName: 'header-grid', field: 'id', headerName: 'ID', width: 80,
    },
    {
      headerClassName: 'header-grid', field: 'id_departamento', headerName: 'Departamentos', width: 290,
      renderCell: (params) => {
        if (!params.row.id_departamento) return "...";

        const ids = params.row.id_departamento.split(",");
        const nombres = ids.map((id) => {
          const dep = departamentosLista.find((d) => d.id === Number(id));
          return dep ? dep.nombre : id;
        });
        return (
          <HtmlTooltip
            placement="right-start"
            enterDelay={500}
            leaveDelay={200}
            TransitionComponent={Zoom}
            title={
              <React.Fragment>
                <Typography color="inherit">{nombres.join(", ")}</Typography>
              </React.Fragment>
            }
          >
            <span style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
              {nombres.join(", ")}
            </span>
          </HtmlTooltip>
        );
      }
    },
    {
      headerClassName: 'header-grid', field: 'nombre', headerName: 'Nombre', width: 300,
    },
    {
      headerClassName: 'header-grid', field: 'proveedor', headerName: 'Proveedor', width: 170,
    },
    {
      headerClassName: 'header-grid', field: 'marca', headerName: 'Marca', width: 170,
    },
    {
      headerClassName: 'header-grid', field: 'eco', headerName: 'Eco', width: 40,
      renderCell: (params) => {
        let eco = params.row.eco;

        return eco === 1 ? (
          <IconButton className="icon-button" rel="noopener noreferrer">
            <CheckCircleIcon color="success" />
          </IconButton>
        ) : ' ';
      }
    },
    {
      headerClassName: 'header-grid', field: 'pdf', headerName: 'PDF', width: 40, sortable: false, align: 'center',
      renderCell: (params) => {
        const id = params.row.id;
        const url = `https://api.workers.grupotel.com/documentos/productos_quimicos/${String(id).padStart(6, '0')}.pdf`;

        return (
          <IconButton
            className='icon-button'
            component="a"
            href={url}
            target="_blank"
            rel="noopener noreferrer"
          >
            <PictureAsPdfIcon />
          </IconButton>
        );
      }
    },
    {
      headerClassName: 'header-grid', field: 'qr', headerName: 'QR', width: 40, sortable: false, align: 'center',
      renderCell: (params) => <ColumnaQR id={params.row.id} nombre={params.row.nombre} />
    }
  ]

  const [primerHotel, setPrimerHotel] = React.useState(true);

  const [actualizo, setActualizo] = useState(true);
  const actualizarProductos = () => {
    setActualizo(!actualizo);
  };

  const [listaTodosProductos, setListaTodosProducto] = useState([]);

  let hoteles = localStorage.getItem('hoteles');
  const [hotelTrabajo, setHotelTrabajo] = useState(0);
  const [hotelesLista, setHotelesLista] = useState([]); // Todos los hoteles

  const cambiaHotelTrabajo = async (event) => {
    if (event.target.name === 'id_hotel') {
      const idHotel = event.target.value;
      setHotelTrabajo(idHotel);
      getProductos(idHotel);
    }
  };

  let departamentoUser = localStorage.getItem('id_departamento');

  // ***********************************************************
  // Dialog Filtrar
  const [estadoFiltro, setEstadoFiltrar] = React.useState(false);
  const [activoFiltro, setActivoFiltro] = React.useState(false);

  const estadoInicial = {
    id: '',
    nombre: '',
    proveedor: '',
    marca: '',
    activo: '',
    id_departamento: '',
    eco: ''
  };
  const [filtros, setFiltros] = useState(estadoInicial);
  const [tempFiltros, setTempFiltros] = useState(estadoInicial);

  const mostrarFiltros = () => {
    // Creamos una copia temporal de filtros
    setTempFiltros(filtros);
    setEstadoFiltrar(true);
  };
  const comprobarESCFiltrar = (event) => {
    if (event.keyCode === 27) {
      cancelFiltrar();
    }
  };
  const cancelFiltrar = () => {
    setTempFiltros(filtros);
    setEstadoFiltrar(false);
  };
  const borrarFiltros = () => {
    setFiltros(estadoInicial);
    setTempFiltros(estadoInicial);
  };

  const filtrarProductos = () => {
    setFiltros(tempFiltros);
    setEstadoFiltrar(false);

    // Comprobar filtros
    actualizarProductos();
  };

  const actualizarFiltros = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      if (checked) {
        setTempFiltros((prev) => ({ ...prev, [name]: 1 }));
      } else {
        setTempFiltros((prev) => ({ ...prev, [name]: 0 }));
      }
    } else {
      setTempFiltros((prev) => ({ ...prev, [name]: value }));
    }
  };

  const comprobarEnter = (e) => {
    if (e.key === 'Enter') {
      actualizarProductos();
    }
  };

  // ***********************************************************

  const [departamentosLista, setDepartamentosLista] = useState([]);

  const getDepartamentos = () => {
    const fd = new FormData();
    fd.append("f", "usuarios.getDepartamentos");
    fd.append("token", localStorage.getItem('token'));

    const requestOptions = {
      method: 'POST',
      body: fd
    };
    fetch(API_URL, requestOptions)
      .then(response => response.json())
      .then(result => {
        let error = result.error;
        if (error.id === 0) {
          // console.log("Informacion de Departamentos");
          // console.log(result);
          const departamentos = Object.entries(result.departamentos).map(([id, nombre]) => ({
            id: Number(id),
            nombre: nombre
          }));
          // Filtramos [Desarrollo, Sistema informaticos, Maestro]
          const excluir = [71, 3, 1000];
          const filtrados = departamentos.filter((dep) => !excluir.includes(dep.id));

          filtrados.sort((a, b) =>
            a.nombre.localeCompare(b.nombre, "es", { sensitivity: "base" })
          );

          departamentos.unshift({ "id": "", "nombre": "..." });
          setDepartamentosLista(departamentos);
        } else {
          mostrarError(error.msg);
          console.log(error);
        }
      })
      .catch(() => {
        mostrarError("No se ha podido obtener la informacion de los Departamentos ");
      })
  };

  // ***********************************************************
  const getQRProductos = async () => {
    if (!listaTodosProductos || listaTodosProductos.length === 0) {
      mostrarError("No hay productos para generar el PDF");
      return;
    }

    const doc = new jsPDF();
    const pageWidth = doc.internal.pageSize.getWidth();
    const margin = 10;
    const qrSize = 50;
    const textHeight = 10; // 12

    let x = margin;
    let y = margin;

    for (let i = 0; i < listaTodosProductos.length; i++) {
      const prod = listaTodosProductos[i];
      const url = `https://api.workers.grupotel.com/documentos/productos_quimicos/${String(
        prod.id
      ).padStart(6, "0")}.pdf`;

      // Generamos QR como DataURL directamente
      const qrImg = await QRCode.toDataURL(url, {
        width: qrSize * 3,
        color: {
          dark: "#00A2DC",   // color de los módulos (azul)
          // dark: "#000000", 
          light: "#FFFFFF"   // color de fondo
        }
      });

      // Añadimos QR al PDF
      doc.addImage(qrImg, "PNG", x, y, qrSize, qrSize);
      // doc.text(`ID: ${prod.id}`, x, y + qrSize + 5);
      // doc.text(`${prod.nombre}`, x, y + qrSize + textHeight);
      doc.setFontSize(12);
      doc.text(`ID: ${prod.id}`, x + qrSize / 2, y + qrSize + 5, { align: "center" });
      // Texto nombre (multilínea y centrado)
      const maxTextWidth = qrSize + 10; // un poco más ancho que el QR
      const nombreLimpio = prod.nombre || "";
      const nombreDividido = doc.splitTextToSize(nombreLimpio, maxTextWidth);

      doc.text(nombreDividido, x + qrSize / 2, y + qrSize + textHeight, { align: "center" });


      // Siguiente columna
      x += qrSize + 20;
      if (x + qrSize > pageWidth - margin) {
        x = margin;
        y += qrSize + textHeight + 20;
      }

      // Salto de página
      if (y + qrSize > doc.internal.pageSize.getHeight() - margin) {
        doc.addPage();
        x = margin;
        y = margin;
      }
    }

    doc.save("QR_Productos.pdf");
  };

  // ***********************************************************

  const getProductos = (idHotel = 0) => {
    fd.append("f", "producto.getProductos");
    fd.append("token", localStorage.getItem('token'));

    let hayFiltros = false;
    if (filtros.id != '') { fd.append("id", filtros.id.trim()); hayFiltros = true; }
    if (filtros.nombre != '') { fd.append("nombre", filtros.nombre.trim()); hayFiltros = true; }
    if (filtros.proveedor != '') { fd.append("proveedor", filtros.proveedor.trim()); hayFiltros = true; }
    if (filtros.marca != '') { fd.append("marca", filtros.marca.trim()); hayFiltros = true; }
    if (filtros.activo != '') { fd.append("activo", filtros.activo.trim()); hayFiltros = true; }
    if (filtros.eco != '' && filtros.eco != 0) { fd.append("eco", filtros.eco); hayFiltros = true; }

    if (idHotel && idHotel != 0) {
      fd.append("id_hotel", idHotel);
    } else {
      if (hotelTrabajo != 0) { fd.append("id_hotel", hotelTrabajo); }
    }

    // Departamento del usuario
    if (filtros.id_departamento != '') {
      fd.append("id_dep", filtros.id_departamento);

      // Si el usuario es desarrollo o director
      if (filtros.id_departamento != '' && (departamentoUser == 71 || departamentoUser == 4 || departamentoUser == 72 || departamentoUser == 1000)) {
        hayFiltros = true;
      }
    } else {
      if (departamentoUser != 71 && departamentoUser != 4 && departamentoUser != 72 && departamentoUser != 1000) {
        fd.append("id_dep", localStorage.getItem('id_departamento'));
      }
    }

    setActivoFiltro(hayFiltros);

    fetch(API_URL, requestOptions)
      .then(response => response.json())
      .then(result => {
        let error = result.error;

        // console.log(result);
        if (error.id === 0) {
          mostrarError("Productos obtenidos", "success");
          setListaTodosProducto(result.data);
        } else {
          mostrarError(error.msg);
          console.log(error.msg);
        }
      })
      .catch(() => {
        mostrarError("No se ha podido obtener el producto");
      })

  };

  useEffect(() => {
    let listaHoteles = JSON.parse(hoteles);
    setHotelesLista(listaHoteles);

    if (primerHotel) {
      let idHotel = localStorage.getItem('idHotelSeleccionado');
      if (idHotel) {
        setHotelTrabajo(idHotel);
        setPrimerHotel(false);
        getProductos(idHotel);

      } else {
        if (listaHoteles[0].value) {
          setHotelTrabajo(listaHoteles[0].value);
          getProductos(listaHoteles[0].value);
        }
      }

      // if (departamentoUser == 71 || departamentoUser == 4) {
      getDepartamentos();
      // }

    }
  }, [primerHotel]);

  useEffect(() => {
    // Función getProductos
    getProductos();
    let tiempoActualizar = 60000 * 5;//Tiempo para actualizar desde la ultima carga 5 min
    const timer = setTimeout(() => { //Iniciamos el timer
      setActualizo(!actualizo);
      getProductos();
    }, tiempoActualizar);
    return () => clearTimeout(timer);//Detenemos el timer para que si realizamos algun cambio no quede un timer que recargue los componentes.

  }, [actualizo])

  return (
    <>
      <div className='container'>
        <div className='content'>
          <div className='article'>
            <div>
              <div className='header'>
                <div className='containerAcciones'>
                  <TextField
                    className='hotelProducto'
                    variant="outlined"
                    margin="normal"
                    label="Hotel"
                    name="id_hotel"
                    size="small"
                    value={hotelTrabajo ? hotelTrabajo : ""}
                    onChange={cambiaHotelTrabajo}
                    select
                    SelectProps={{
                      MenuProps: {
                        PaperProps: {
                          sx: { maxHeight: { sm: 36 * 8 + 8 } }
                        }
                      }
                    }}
                  >
                    {/* <MenuItem value={0}></MenuItem> */}
                    {hotelesLista.map((hotel) => (
                      <MenuItem key={hotel.value} value={hotel.value} >
                        {hotel.label}
                      </MenuItem>
                    ))}
                  </TextField>

                  <ButtonGroup className="botonera" variant="contained" aria-label="outlined button group">
                    <HtmlTooltip
                      placement="bottom" enterDelay={500} leaveDelay={200} TransitionComponent={Zoom}
                      title={
                        <React.Fragment>
                          <Typography color="inherit">{"Filtrar"}</Typography>
                        </React.Fragment>
                      }
                    >
                      <Button
                        className={activoFiltro === true ? "boton filtro pintado" : "boton filtro"}
                        onClick={mostrarFiltros}
                      >
                        <FilterAltIcon className='icon-button' />
                      </Button>
                    </HtmlTooltip>
                    <HtmlTooltip
                      placement="bottom" enterDelay={500} leaveDelay={200} TransitionComponent={Zoom}
                      title={
                        <React.Fragment>
                          <Typography color="inherit">{"Actualizar"}</Typography>
                        </React.Fragment>
                      }
                    >
                      <Button
                        className="boton"
                        onClick={actualizarProductos}
                      >
                        <RotateLeftIcon className='icon-button' />
                      </Button>
                    </HtmlTooltip>
                    <HtmlTooltip
                      placement="bottom" enterDelay={500} leaveDelay={200} TransitionComponent={Zoom}
                      title={
                        <React.Fragment>
                          <Typography color="inherit">{"QR Productos"}</Typography>
                        </React.Fragment>
                      }
                    >
                      <Button
                        className="boton"
                        onClick={getQRProductos}
                      >
                        <QrCodeScannerIcon className='icon-button' />
                      </Button>
                    </HtmlTooltip>
                  </ButtonGroup>

                </div>
              </div>
            </div>
          </div>

          {/* Lado derecho */}
          {/* <div className='aside' >
            <div className='header'>
              <div className='containerAcciones'>

              </div>
            </div>
            <div className='grid-container'>
            </div>
          </div> */}
        </div>
        <div className='grid-container'>
          <DataGrid
            className='grid'
            rowHeight={52}//63
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0 ? ' blanco' : ' fondogris blanco'
            }
            getRowId={(listaTodosProductos) => listaTodosProductos.id}
            onRowClick={''}
            rows={listaTodosProductos}
            columns={(departamentoUser == 71 || departamentoUser == 4 || departamentoUser == 72 || departamentoUser == 1000) ? columnasDep : columnas}
            maxColumns={6}
            pageSize={12}
            rowsPerPageOptions={[12]}
            initialState={{
              sorting: {
                sortModel: [{ field: 'nombre', sort: 'asc' }],
              },
            }}
            localeText={{
              noRowsLabel: "No se ha encontrado datos.",
              noResultsOverlayLabel: "No se ha encontrado ningún resultado",
            }}
          />

        </div>

        <CargaSpinner contadorSpinner={contadorSpinner} />
        <MostrarError mensajeEr={mensajeError} tipoError={tipoError} contadorError={contadorError} estadoAlert={estadoAlert} />

        <Dialog fullScreen={fullScreen}
          open={estadoFiltro}
          onClose={comprobarESCFiltrar}
          aria-labelledby="responsive-dialog-title" id="dialogFiltroProductos">
          <DialogTitle>Filtrar Productos</DialogTitle>
          <DialogContent>
            <div className='bloque-inputs-filtros'>
              <TextField
                variant="outlined"
                margin="normal"
                type="text"
                label="ID"
                onKeyPress={comprobarEnter}
                name="id"
                size="small"
                className='inputIdFiltro'
                value={tempFiltros.id || ''}
                onChange={actualizarFiltros}
                autoComplete="off"
              />
              <TextField
                variant="outlined"
                margin="normal"
                label="Nombre"
                onKeyPress={comprobarEnter}
                name="nombre"
                size="small"
                className='inputNombreFiltro'
                value={tempFiltros.nombre || ''}
                onChange={actualizarFiltros}
                autoComplete="off"
              />
            </div>
            <div className='bloque-inputs-filtros'>
              <TextField
                variant="outlined"
                margin="normal"
                label="Proveedor"
                onKeyPress={comprobarEnter}
                name="proveedor"
                size="small"
                className='inputProductoFiltro'
                value={tempFiltros.proveedor || ''}
                onChange={actualizarFiltros}
                autoComplete="off"
              />
              <TextField
                variant="outlined"
                margin="normal"
                label="Marca"
                onKeyPress={comprobarEnter}
                name="marca"
                size="small"
                className='inputProductoFiltro'
                value={tempFiltros.marca || ''}
                onChange={actualizarFiltros}
                autoComplete="off"
              />
            </div>
            <div className='bloque-inputs-filtros'>
              {
                (departamentoUser == 71 || departamentoUser == 4 || departamentoUser == 72 || departamentoUser == 1000) ?
                  <TextField
                    variant="outlined"
                    margin="normal"
                    label="Departamento"
                    name="id_departamento"
                    size="small"
                    className='anchoDepFicha'
                    value={tempFiltros.id_departamento || ''}
                    onChange={actualizarFiltros}
                    select
                  >
                    {departamentosLista.map((departamento) => (
                      <MenuItem key={`filtrosDep-${departamento.id}`} value={departamento.id}>
                        {departamento.nombre}
                      </MenuItem>
                    ))}
                  </TextField>
                  : <></>
              }

              <div className='divDisContent justificarCentro centrar'>
                <FormControl component="fieldset" style={{ marginTop: "16px" }}>
                  <FormLabel component="legend">Estado</FormLabel>
                  <RadioGroup
                    row
                    name="activo"
                    value={tempFiltros.activo}
                    onChange={actualizarFiltros}
                  >
                    <FormControlLabel value="" control={<Radio />} label="Todos" />
                    <FormControlLabel value="1" control={<Radio />} label="Activos" />
                    <FormControlLabel value="0" control={<Radio />} label="Inactivos" />
                  </RadioGroup>
                </FormControl>
              </div>

              <div className='divAplazado'>
                <FormControlLabel
                  control={<Checkbox checked={!!tempFiltros.eco} onChange={actualizarFiltros}
                  className='checkBoxColor' name="eco" />}
                  label="Ecofriendly"
                />
              </div>
            </div>

          </DialogContent>
          <DialogActions>
            <Button className="colorGrupo botonBorrarFiltros" onClick={borrarFiltros}>Limpiar Filtros</Button>
            <ButtonGroup className="botonera" variant="contained" aria-label="outlined button group">
              <Button className="colorGrupo borrarBoton" onClick={cancelFiltrar}>Cancelar</Button>
              <Button className="colorGrupo" onClick={filtrarProductos}>Filtrar</Button>
            </ButtonGroup>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
}

export default FichasTecnicas;